import BackofficeResiliationRequestsBase from './BackofficeResiliationRequestsBase';

export default class BackofficeResiliationRequestsIndex extends BackofficeResiliationRequestsBase {
  constructor() {
    super('resiliation-requests-table', 4);
  }

  bindEvents() {
    super.bindEvents();
  }

  onDataChanged(data) {
    // Logic spécifique aux demandes de résiliation
  }
}